/**
 * created by zhouzt on 2020-05-08
 *
 * description: 列表基础模板
 *
 */

import utils from 'libs/utils'
import http from 'libs/http'
import config from 'libs/config'

import Dialog from 'libs/dialog'
import Pagination from 'template/dot/layout/pagination'

import indexTpl from './components/index.dot'
import tableTpl from './components/table.dot'

export default class ListDialog extends Dialog {
	/**
	 * description: 构造函数
	 *
	 * @param {String} pkid 唯一标识
	 * @param {String} title 标题
	 * @param {Object} api 接口配置
	 * @param {String} api.url 接口地址
	 * @param {Object} api.params 请求参数
	 * @param {Array} [filters = []] 筛选条件
	 * @param {Array} [thead = []]  表头
	 * @param {String} [confirmBtn = '添加'] 确认按钮名称
	 * @param {Array} extraBtns 其余按钮
	 * @param {String} extraBtns.name 按钮名称
	 * @param {String} extraBtns.id 按钮 id
	 * @param {Function} extraBtns.cb 按钮回调
	 *
	 * created by zhouzt on 2020-05-08
	 *
	 */
	constructor (pkid, title, api, filters = [], thead = [], confirmBtn = '确定', extraBtns = []) {
		super({
			pkid: pkid,
			title: title,
			class: 'dialog_list',
			contentHTML: utils.replacePath(indexTpl({
				filters: filters,
				thead: thead,
				confirmBtn: confirmBtn || '确定',
				extraBtns: extraBtns
			})),
			width: 880
		})

		// 接口配置
		this.api = api
		// 过滤条件
		this.filters = filters || []
		// 表头
		this.thead = thead || []
		// 额外按钮
		this.extraBtns = extraBtns

		// 供应商表格数据
		this.list = []
		// 当前选中数据
		this.data = null
		// 分页数据
		this.pageData = {
			currPage: 1,
			pageSize: 10,
			totalPage: 0
		}
		// 回调函数
		this.cb = null
		// 默认提示语
		this.msg = '请选择数据'

		// 绑定事件
		this.bindListEvent()
	}

	/**
	 * description: 初始化弹窗
	 *
	 * @param {Function} cb	回调函数
	 *
	 * created by zhouzt on 2020-05-08
	 *
	 */
	init (cb, text = '请选择数据') {
		// 供应商表格数据
		this.list = []
		// 当前选中数据
		this.data = null
		// 回调函数
		this.cb = cb
		// 默认提示语
		this.msg = text
		// 分页数据
		this.pageData = {
			currPage: 1,
			pageSize: 10,
			totalPage: 0
		}

		// 打开弹窗
		this.open()
		// 获取数据
		this.getData()
	}

	/**
	 * description: 获取数据
	 *
	 * created by zhouzt on 2020-05-08
	 *
	 */
	getData () {
		// 请求参数
		let params = {
			url: this.api.url,
			data: {
				...this.api.params,
				...utils.serialize(`#dialog_${this.pkid} .filters`),
				...this.pageData,
				page: this.pageData.currPage
			}
		}

		if (params.data.groupflag) {
			params.data.groupFlag = params.data.groupflag
		}

		// 远程调用
		return new Promise((resolve, reject) => {
			// 开启表格loading效果
			utils.tableLoading(`#dialog_${this.pkid} #table`)
			http.ajax(params, res => {
				// 表格数据
				this.list = res.list
				// 关闭表格loading效果
				utils.unTableLoading(`#dialog_${this.pkid} #table`)
				$(`#dialog_${this.pkid} #table`).html(utils.replacePath(tableTpl({
					list: this.list || [],
					thead: this.thead,
					pkid: this.pkid,
					path: config.DOC_PATH
				})))

				this.pageData.totalPage = res.totalPage
				this.pageData.totalCount = res.totalCount

				// 分页实例化
				let pagination = new Pagination({
					binding: `#dialog_${this.pkid} #pagination`,
					pageData: this.pageData,
					callback: this.changeParams.bind(this)
				})

				// 渲染分页
				pagination.render()

				resolve(res)
			}, err => {
				// 关闭表格loading效果
				utils.unTableLoading(`#dialog_${this.pkid} #table`)
				$(`#dialog_${this.pkid} #table`).html(utils.replacePath(tableTpl({
					list: [],
					thead: this.thead
				})))
				reject(err)
			})
		})
	}

	/**
	 * description: 绑定事件
	 *
	 * created by zhouzt on 2020-05-08
	 *
	 */
	bindListEvent () {
		const that = this

		// 点击【关闭】按钮关闭弹窗
		$('body').on('click', `#dialog_${this.pkid} .close_dialog_btn`, function () {
			that.close()
		})

		// 点击【查询】加载 loading
		$('body').on('click', `#dialog_${this.pkid} .search_btn`, function () {
			// 开启按钮loading效果
			utils.btnLoading($(this).parent())
			// 兄弟 span 加载 loading 效果
			$(this).parent().siblings().each((index, ele) => {
				// 开启按钮loading效果
				utils.btnLoading($(ele))
			})

			// 调用查询接口
			that.getData().then(() => {
				// 关闭按钮loading效果
				utils.unBtnLoading($(this).parent())
				// 兄弟 span 关闭 loading 效果
				$(this).parent().siblings().each((index, ele) => {
					// 关闭按钮loading效果
					utils.unBtnLoading($(ele))
				})
			}).catch(() => {
				// 关闭按钮loading效果
				utils.unBtnLoading($(this).parent())
				// 兄弟 span 关闭 loading 效果
				$(this).parent().siblings().each((index, ele) => {
					// 关闭按钮loading效果
					utils.unBtnLoading($(ele))
				})
			})
		})

		// 点击【清空】清空查询数据项
		$('body').on('click', `#dialog_${this.pkid} .clear_btn`, function () {
			// 清空数据
			$(this).parents('.frame_buttons').siblings('ol').find('li').each((index, ele) => {
				// 清空 input 值
				$(ele).find('input').val('')
				// 清空下拉选项
				$(ele).find('.slidkey').removeClass('on').find('em').text('请选择')
				$(ele).find('.slidkey').find('i').removeClass('icon-guanbi').addClass('icon-xialacaidan')
			})
			// 开启按钮loading效果
			utils.btnLoading($(this).parent())
			// 兄弟 span 加载 loading 效果
			$(this).parent().siblings().each((index, ele) => {
				// 开启按钮loading效果
				utils.btnLoading($(ele))
			})

			// 调用查询接口
			that.getData().then(() => {
				// 关闭按钮loading效果
				utils.unBtnLoading($(this).parent())
				// 兄弟 span 关闭 loading 效果
				$(this).parent().siblings().each((index, ele) => {
					// 关闭按钮loading效果
					utils.unBtnLoading($(ele))
				})
			}).catch(() => {
				// 关闭按钮loading效果
				utils.unBtnLoading($(this).parent())
				// 兄弟 span 关闭 loading 效果
				$(this).parent().siblings().each((index, ele) => {
					// 关闭按钮loading效果
					utils.unBtnLoading($(ele))
				})
			})
		})

		// 点击【单选框】选择数据
		$('body').on('click', `#dialog_${this.pkid} .radio-label`, function () {
			setTimeout(() => {
				that.data = that.list[$(`#dialog_${that.pkid} input[name="${that.pkid}_code"]:checked`).val()]
			}, 0)
		})

		// 点击【添加】添加选择数据
		$('body').on('click', `#dialog_${this.pkid} .list_confirm_btn`, function () {
			if (that.data) {
				// 有数据回调
				if (that.cb) {
					that.cb(that.data)
				}
				// 关闭弹窗
				that.close()
			} else {
				// 没有数据提示
				// 消息提示【请选择数据】
				utils.alert({
					type: 'warning',
					message: that.msg
				})
			}
		})

		this.extraBtns.forEach(item => {
			// 自定义按钮组点击操作
			$('body').on('click', `#dialog_${this.pkid} .list_${item.id}_btn`, function () {
				if (item.cb) {
					item.cb(that.close.bind(that))
				}
			})
		})
	}

	/**
	 * description: 修改分页器页码
	 *
	 * @param {Number} page 页码
	 * @param {Number} size 分页大小
	 *
	 * created by zhouzt on 2020-03-20
	 *
	 */
	changeParams (page, size) {
		this.pageData.currPage = page || this.pageData.currPage
		this.pageData.pageSize = size || this.pageData.pageSize

		// 重新获取数据
		this.getData()
	}

	/**
	 * description: 更新弹窗
	 *
	 * created by zhouzt on 2020-06-12
	 *
	 */
	updatePromise (filters, thead, confirmBtn, extraBtns) {
		this.filters = filters
		this.thead = thead
		this.update(utils.replacePath(indexTpl({
			filters: filters,
			thead: thead,
			confirmBtn: confirmBtn || '确定',
			extraBtns: extraBtns
		})))
	}
}



// WEBPACK FOOTER //
// ./src/template/dot/dialog/list/index.js